/**
 * Weekly Game Plan + Pulse
 *
 * The Game Plan is one shared checklist per company per week (Monday 00:00
 * to Monday 00:00, New York time). Three items are computed from live data;
 * the self-reported ones live on a CompanyWeek record that every admin of the
 * company reads and updates. The Pulse summarises the previous week.
 *
 * Table: crewcast-company-weeks-{env}, PK companyId, SK weekStart.
 */
export const KUDOS_SOURCES = ['game-plan', 'employee-profile', 'employees-page'];
export const KUDOS_DEFAULT_MESSAGE = "Great work this week! Thanks for everything you're doing.";
export const KUDOS_MAX_MESSAGE_LENGTH = 280;
export const KUDOS_MAX_POINTS = 10000;
